import { addJs } from '../utils/documentMethods';

const ADOBE_DATA_LAYER_CONCERN_CODE = 'adl';
const ADOBE_DATA_LAYER_CONCERN_KEY = 'adobeDataLayer';

declare global {
  interface Window {
    adobeLaunch: {
      initializePage: (page: any, rte: string) => void;
    };
  }
}

export default class AdobeDataLayerProcessor {
  process(baseConfig: any, { rte }) {
    const dataLayerConfig = baseConfig[ADOBE_DATA_LAYER_CONCERN_KEY];
    const scriptSrcMin = dataLayerConfig.script.src.minified;
    addJs(scriptSrcMin, 'head', { id: 'adl' });
    this.init(this.getAcceptableRte(rte));
  }

  getConcernCode() {
    return ADOBE_DATA_LAYER_CONCERN_CODE;
  }

  private getAcceptableRte(rte): string {
    return rte.toUpperCase() === 'PROD' ? 'production' : 'development';
  }

  private init(rte: string) {
    const page = {};
    const adlScript = document.getElementById('adl');
    adlScript?.addEventListener('load', () => {
      window.adobeLaunch.initializePage(page, rte);
    });
  }
}
